// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"154892d5","453":"807d2ac9","455":"6d68b0a0","977":"46391add"}[chunkId] + ".chunk.js";
};